module.exports = __webpack_public_path__ + "media/images/speechBubble-71da55fa2f145dcf42def3892161aa78.png";